import React from 'react';
import PropTypes from 'prop-types';
import OverlayController from '../overlay/OverlayController';
import Dialog from '../overlay/Dialog';
import mutations from '../../graphql/mutations';
import RaisedButton from 'material-ui/RaisedButton';
import muiThemeable from 'material-ui/styles/muiThemeable';
import { compose } from 'react-apollo';
import './APIKeys.css'


class APIKeys extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            apiSecretKey: props.project.apiSecretKey
        };
    }

    didClickGenerateNewKeyButton() {
        let actions = [
            {label: 'Cancel', handler: () => OverlayController.hideOverlay()},
            {label: 'Generate', secondary: true, handler: this.generateNewKey.bind(this)}
        ];
        OverlayController.showOverlay({
            component: (
                <Dialog title={`Are you sure you want to generate new API key?`} actions={actions} >
                    <div style={{textAlign: 'center'}}>Changing the API key will invalidate the current key.</div>
                </Dialog>
            )
        });
    }

    generateNewKey() {
        OverlayController.hideOverlay();
        OverlayController.showActivityIndicator();
        this.props.generateNewAPIKey(this.props.project.id)
            .then(({data}) => {
                console.log('got data', data);
                OverlayController.hideActivityIndicator();
                this.setState({
                    apiSecretKey: data.generateNewAPIKey.apiSecretKey
                });
            })
            .catch((error) => {
                console.log('there was an error generating new api key:', error);
                OverlayController.hideActivityIndicator();
                OverlayController.showErrorAlert(error);
            });
    }

    render() {
        let isCurrentUserAdmin = (this.props.project.aclRole === "admin");
        return (
            <div className="api-key-section">
                <div className="api-key-label">Project ID:</div>
                <div className="api-key-value">{this.props.project.id}</div>
                <div className="api-key-label">Secret Key:</div>
                <div className="api-key-value">{this.state.apiSecretKey}</div>
                {isCurrentUserAdmin &&
                <RaisedButton
                    className="generate-new-api-key-button"
                    label="Generate New Secret Key"
                    primary={true}
                    onTouchTap={() => this.didClickGenerateNewKeyButton()}
                />
                }
            </div>
        );
    }

}

APIKeys.propTypes = {
    project: PropTypes.object.isRequired
};

APIKeys.defaultProps = {};

export default compose(
    mutations.generateNewAPIKeyMutationHoc
)(muiThemeable()(APIKeys));



// WEBPACK FOOTER //
// ./src/components/projectSettings/APIKeys.js